import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AiAssistantService, AssistantDefinition} from '../../services/ai-assistant.service';
import {AiMessageViewModel, HumanMessageViewModel, IAiChatMessage} from "../ai-message/ai-message-view.model";
import {UserService} from "../../../user/services/user/user.service";

@Component({
  selector: 'app-assistant-conversation',
  templateUrl: './assistant-conversation.component.html',
  styleUrls: ['./assistant-conversation.component.scss']
})
export class AssistantConversationComponent implements OnInit {
  @Input() assistant: AssistantDefinition;
  @Output() backToSelection: EventEmitter<void> = new EventEmitter<void>();
  query: string = '';
  currentMessage?: string;
  searching = false;
  private canSearch = true;
  messages: IAiChatMessage[] = [];

  constructor(private aiAssistantService: AiAssistantService,
              private userService: UserService) {
    this.aiAssistantService.chatUpdateEvent.subscribe((result) => {
      if (result.message) {
        this.currentMessage = result.message;
      }
    });
  }

  ngOnInit(): void {
  }

  async search() {
    if (!this.query) {
      return;
    }
    if (!this.canSearch) {
      return;
    }
    this.canSearch = false;
    this.searching = true;
    const query = this.query;
    const humanMesssage = new HumanMessageViewModel(this.userService.currentUser, query);
    this.messages.push(humanMesssage);
    this.query = '';
    this.currentMessage = 'If you see this, something went wrong.';
    try {
      const aiMessage = new AiMessageViewModel(this.assistant, '');
      this.messages.push(aiMessage);
      const result = await this.aiAssistantService.askQuestion(this.assistant, query, aiMessage);
      aiMessage.message = result.message;
      aiMessage.finished = true;
    } catch (e) {
      this.currentMessage = e.message;
    }
    this.searching = false;
    this.canSearch = true;
    this.currentMessage = undefined;
  }

  goBackToSelection() {
    this.backToSelection.emit();
  }
}
